<template lang="pug">
  .dashboard-container
    .dashboard-content
      Sidenav
      .dashboard-main-content(:class="{'is-open': isSidenavOpen, 'is-close': isSidenavClose}")
        b-navbar.bb-1(toggleable="lg", type="" )
          b-form-row.align-items-center.w-100
            b-col(cols="auto")
              .d-lg-none
                menu-icon(@click="toggleSidenav('sidenav-close-button', 'open', !isSidenavOpen)")
              .d-none.d-lg-flex.pointer
                menu-icon(@click="toggleSidenav('sidenav-close-button', 'close', false)", v-if="isSidenavClose")
                bar-chart-icon.sidenav-button(@click="toggleSidenav('sidenav-close-button', 'close', true)", v-else)
            b-col
              b-breadcrumb.mb-0.py-0(:items="getBreadcrumbRoutes")
            b-col(cols="auto")
              b-collapse(id="nav-collapse", is-nav)
                b-form-row.align-items-center
                  b-col.mb-1.mb-md-0(md="auto")
                    wifi-icon.text-success(v-if="client_connected", v-b-tooltip="'Conectado a mensajería'") d
                    div(v-else)
                      b-spinner.mr-1(small, type="grow", variant="primary")
                      small.text-primary Conectando con servicio de mensajería
                  b-col.mb-1.mb-md-0(md="auto", v-if="whatsapp_link")
                    b-button(variant="outline-info", size="sm", :href="whatsapp_link", target="_blank" )
                      v-icon.mr-1(name="brands/whatsapp")
                      span Ayuda
                  b-col.mb-1.mb-md-0(md="auto")
                    b-button(variant="outline-info" size="sm" data-canny-changelog)
                      zap-icon.mr-1.icon-sm
                      span Actualizaciones
                  b-col.mb-1.mb-md-0(md="auto")
                    b-button(variant="outline-info" pill size="sm" @click="notifications_modal = true;")
                      v-icon(name="bell")
                      b-badge.ml-1(variant="outline-info" v-if="notifications.length > 0") {{ notifications.length }}
          b-navbar-toggle.p-0(target="nav-collapse")
            template(#default="{ expanded }")
              v-icon(name="chevron-up", v-if="expanded")
              v-icon(name="chevron-down", v-else)
        .router-content#router-container
          CallPanel(v-show="isCallPanelOpen", :isCallPanelOpen="isCallPanelOpen", :caller="caller", :call="call", :token="token")
          router-view(:class="isCallPanelOpen ? 'callPanelHeight' : 'h-100'")
          ScrollTop.d-flex.justify-content-end.position-absolute(id="button-to-scroll-up", element_id="router-container",  :right="'30'", :bottom="'80'", :container="scrollButton")
      SideModal(v-model="side_modal_ecommerce", size="md", @input="side_modal_ecommerce = false")
        SellMoreTips
      SideModal(v-model="notifications_modal", padding="1rem")
        b-row.align-items-center.mb-3
          b-col
            span.font-weight-bold Notificaciones
          b-col(cols="auto")
            b-link.text-info.text-sm(@click="markAllRead") Marcar todas como leídas

        .my-3.text-center
          b-spinner(type="grow" v-if="loading" variant="primary")

        b-list-group.mb-3
          b-list-group-item(v-if="!notifications.length && !loading")
            b-form-row
              b-col(cols="auto")
                bell-off-icon.text-secondary
              b-col
                p.mb-0.text-secondary No hay notificaciones por el momento
          b-list-group-item(v-for="(notification, index) in notifications", :key="index", :class="{'bg-active-notification': !notification.read}" @click="openNotification(notification)")
            b-form-row
              b-col(cols="auto")
                shopping-cart-icon.text-success.pointer(v-if="notification.type === 'order'")
                message-circle-icon.text-primary.pointer(v-else-if="notification.type === 'case'")
                bell-icon.text-info.pointer(v-else)
              b-col
                p.mb-0.text-sm.font-weight-bold.pointer {{ notification.title }}
                  b-spinner.ml-2(small variant="primary" v-if="notification.loading")
                p.mb-2.text-secondary.pointer {{ notification.description }}
                p.mb-0.text-sm.text-help {{ $moment().calendar(notification.updatedAt) }}
              b-col(cols="auto")
                span.pointer(v-if="!notification.read" style="font-size:22px;" @click.stop="markRead(notification, true)") ●
                span.pointer.text-secondary(v-else style="font-size:22px;" @click.stop="markRead(notification, false)") ○

        b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getNotifications')", v-if="v_paginationShow" size="sm")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import Sidenav from '../../components/SideNav.vue'
import SellMoreTips from '../../components/SellMoreTips'
import ScrollTop from '../../components/ScrollTopBtn'
import mqttClient from '../../helpers/mqtt-client'
import caseSocket from '../../helpers/cases-ws'
import { EventBus } from '../../helpers/eventBus'
import CallPanel from '../../components/CallPanel'

const accountController = createNamespacedHelpers('account')
const notificationController = createNamespacedHelpers('notification')

export default {
  name: 'Dashboard',
  mixins: [mqttClient],
  data () {
    return {
      isCallPanelOpen: false,
      scrollButton: null,
      side_modal_ecommerce: false,
      notifications_modal: false,
      loading: false,
      caseSocket: null,
      call: null,
      caller: null,
      token: '',
      fromNumber: ''
    }
  },
  provide() {
    return {
      caseSocket: this.caseSocket = caseSocket.start(this.$auth.getToken()),
    }
  },
  methods: {
    ...mapActions([
      'platform/all',
      'label/all',
      'account/admins',
      'account/languages',
      'account/bmessaging',
      'notification/all',
      'notification/update',
      'account/getNumbers'
    ]),
    getAccountPlatforms () {
      const self = this

      this['platform/all']({ account_id: self.$route.params.account_id })
    },
    getAccountLabels () {
      const self = this

      this['label/all']({ account_id: self.$route.params.account_id })
    },
    getNotifications () {
      const self = this
      self.loading = true

      this['notification/all']({
        params: {
          ...self.paginationParamsObject,
          account_id: self.$route.params.account_id,
          admin_id: self.getCurrentUser().admin_id
        },
        callback: res => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.parsePaginationDataFromResponse(res)
        }
      })
    },
    markRead (notification, read, callback) {
      this['notification/update']({
        notification_id: notification.notification_id,
        read,
        callback: res => {
          if (res.success) {
            notification.read = read

            if (callback) callback()
          }
        }
      })
    },
    markReadPromise (notification) {
      return new Promise(resolve => {
        this['notification/update']({
          notification_id: notification.notification_id,
          read: true,
          callback: res => {
            resolve()
          }
        })
      })
    },
    markAllRead () {
      const unread = this.notifications.map(n => n).filter(n => !n.read)
      const promises = []

      for (const notification of unread) {
        promises.push(this.markReadPromise(notification))
      }

      Promise.all(promises).then(res => {
        for (const n of unread) {
          const index = this.notifications.findIndex(x => x.notification_id == n.notification_id)

          if (index >= 0) this.notifications[index].read = true
        }
      })
    },
    openNotification (notification) {
      this.$set(notification, 'loading', true)
      this.markRead(notification, true, () => {
        notification.loading = false
        switch (notification.type) {
          case 'case':
            this.$router.push({ name: 'Case', params: { case_id: notification.type_id } }).catch(() => {})
            break
          case 'order':
            this.$router.push({ name: 'Orders', query: { order_id: notification.type_id } }).catch(() => {})
            break
        }

        this.notifications_modal = false
      })
    },
    getAccountAdmins () {
      const self = this

      this['account/admins']({ account_id: self.$route.params.account_id })
    },
    getLanguages () {
      const self = this

      this['account/languages']({ account_id: self.$route.params.account_id })
    },
    getBMessagingData () {
      const self = this

      this['account/bmessaging']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.success) {
            // var script = document.createElement('script')
            // script.src = process.env.VUE_APP_BMID_SDK
            // script.id = 'botlers-messaging-sdk-v2'
            // script.setAttribute('bmid', res.resource.bmid)
            // script.setAttribute('button', 'true')
            // script.setAttribute('skip-start', 'true')
            // script.setAttribute('bm-params', '%7B%22ui%22%3A%7B%22attachFiles%22%3Atrue%2C%22attachImages%22%3Atrue%7D%7D')
            // document.getElementsByTagName('head')[0].appendChild(script)
          }
        }
      })
    },
    initCanny () {
      Canny('initChangelog', {
        appID: '624fd194faf1ec52a550eb83',
        position: 'bottom',
        align: 'right'
      })
    },
    initOneSignal () {
      const self = this
      //if(process.env.VUE_APP_ENV_MODE !== 'production') return

      window.OneSignal = window.OneSignal || []

      OneSignal.push(function() {
        OneSignal.on('subscriptionChange', function (isSubscribed) {
          if (isSubscribed) {
            const user = self.getCurrentUser()

            if (user && user.email) {
              OneSignal.sendTags({"email": user.email, "product": 'socialkit'})
            }
          } else {
            //OneSignal.deleteTags(["email", "product"]);
          }
        })
      })

      window.OneSignal.push(() => {
        window.OneSignal.init({
          appId: process.env.VUE_APP_ONESINGAL_SOCIALKIT_ID,
          allowLocalhostAsSecureOrigin: false
        })
      })
    },
    async getNumbers() {
      const self = this

      this['account/getNumbers']({
        account_id: self.$route.params.account_id,
        callback: async (res) => {
          if (res.error) return self.$message.error(res.error)
        }
      })
    },
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account
    }),
    ...notificationController.mapState({
      notifications: state => state.notifications
    }),
    getBreadcrumbRoutes () {
      try {
        const path = []

        for (const route of this.$route.matched) {
          // if (!route.name) continue
          const name = route.meta ? (route.meta.name || route.name) : route.name

          switch (name) {
            case 'account':
              path.push({ text: name, to: { name: route.name, params: route.params } })
              break
            default:
              path.push({ text: name, to: { name: route.name, params: route.params } })
              break
          }
        }

        return path
      } catch (e) {
        console.error(e.message)

        return this.$route.path.split('/').slice(1)
      }
    },
    isKonverza () {
      return (new RegExp('^konverza', 'i')).test(this.account.type)
    },
    isEcommerce () {
      return (new RegExp('^konverza-ecommerce', 'i')).test(this.account.type)
    },
    isEcommerceServices () {
      return this.account.type === 'konverza-ecommerce-services'
    },
    missingSteps () {
      const steps = []

      if (this.isEcommerce || this.isEcommerceServices) {
        if (!Boolean(this.account.merchant_id)) {
          steps.push({
            title: 'Crea una cuenta de cobros',
            route: this.isPartner ? '' : { name: 'Affiliation' }
          })
        }
      }

      // if ( !Boolean(this.account.plan_id) ) steps.push({
      //   title: 'Selecciona un plan',
      //   route: this.isPartner ? '' : { name: 'Billing' }
      // })

      return steps
    },
    whatsapp_link () {
      if (!process.env.VUE_APP_WHATSAPP_NUMBER) return false

      return `https://wa.me/${process.env.VUE_APP_WHATSAPP_NUMBER}`
    }
  },
  mounted() {
    this.getLanguages()
    this.getBMessagingData()
    this.getNotifications()
    this.initCanny()
    this.getNumbers()

    this.scrollButton = document.getElementById('button-to-scroll-up')

    EventBus.$on('notification/new', (notification) => {
      if (!notification) return

      this.notifications.push(notification)
    })
    EventBus.$on('putIsCallPanelOpen', (value) => { this.isCallPanelOpen = value })
    EventBus.$on('putToken', (value) => { this.token = value })
    EventBus.$on('putCaller', (value) => { this.caller = value })
    EventBus.$on('putCall', (value) => { this.call = value })

    // this.initOneSignal()
    // this.toggleSidenav('inbox-init', 'close')
    // this.getAccountPlatforms()
    // this.getAccountLabels()
    // this.getAccountAdmins()
  },
  watch: {
    '$route' () {
      this.side_modal_ecommerce = false
    },
    notifications_modal (value) {
      this.getNotifications()
    }
  },
  beforeDestroy() {
    Canny('closeChangelog')
  },
  components: {
    Sidenav,
    SellMoreTips,
    ScrollTop,
    CallPanel
  }
}
</script>

<style lang="scss" scoped>
  .callPanelHeight {
    height: calc(100% - 120px) !important;
  }
  .dashboard-container {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .dashboard-content {
    width: 100%;
    // max-width: 1280px;
    margin: 0 auto;
    flex: 1 1 auto;
    display: flex;
    flex-flow: row;
    min-height: 0;
  }

  .dashboard-main-content {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    transition: .5s;

    margin-left: 250px;

    .router-content {
      flex: 1 1 auto;
      padding: 1rem;
      overflow-y: auto;
      height: 100%;
    }
  }

  @media (max-width: 992px) {
    .dashboard-main-content {
      margin-left: 0 !important;
    }
  }

  @media (min-width: 993px) {
    .dashboard-main-content {
      &.is-open {
        margin-left: 250px !important;
      }

      &.is-close {
        margin-left: 0 !important;
      }
    }
  }

  .sidenav-button {
    transform: rotate(90deg) scaleX(-1);
  }

  .bg-active-notification {
    background-color: #fdffe6;
  }

  #button-to-scroll-up {
    padding: 11.5px;
  }
</style>
